<template>
	<div class="create flex start-v">
		<div class="row title flex start" :data-length="`${params.title.length}/20`">
			<label>标 题：</label>
			<input v-model="params.title" maxlength="20" type="text" placeholder="请输入通知标题" />
		</div>

		<div class="row content flex start" :data-length="`${params.content.length}/500`">
			<label>内 容：</label>
			<div>
				<textarea v-model="params.content" maxlength="500" cols="30" rows="10" placeholder="请输入文字"></textarea>
			</div>
		</div>
		<div class="diver"></div>
		<div class="select-student">
			<p class="subtitle">接收通知的班级</p>
			<div v-if="gradeList?.length===0" class="nodata"></div>
			<div @click="selectGrade(item)" v-for="(item,index) in gradeList" :key="index" class="card flex between">
				<p class="text-ellipsis">{{item.teamName}}</p>
				<input type="checkbox" disabled :checked="params.classId==item.teamId" />
			</div>
		</div>

		<div class="footer">
			<button @click="publishNotice" class="btn-full">发送通知</button>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			params: {
				title: "",
				content: "",
				classId: undefined,
			},
			gradeList: [],
		};
	},

	mounted() {
		this.getGradeList();
	},

	methods: {
		selectGrade(gradeItem) {
			if(this.params.classId == gradeItem.teamId) this.params.classId = undefined;
			else this.params.classId = gradeItem.teamId;
		},
		async getGradeList() {
			try {
				let { success, message, result } = await this.$http.get(
					"h5/general/listTeamSize"
				);
				if (!success) throw new Error(message);
				this.gradeList = result;
			} catch (error) {
				console.error("getGradeList", error?.message);
			}
		},

		async publishNotice() {
			let { title, content, classId } = this.params;
			if (!title) return this.$message("请输入要通知的标题");
			if (!classId) return this.$message("请选择要通知的班级");
			try {
				let { success, message } = await this.$http.post("h5/notice/addNotice",this.params);
				if (!success) throw new Error(message);
				this.$message(message);
				this.$router.go(-1);
			} catch (error) {
				this.$message(error?.message);
				console.error("publishNotice", error?.message);
			}
		},
	},
};
</script>

<style scoped lang="less">
.create {
	padding-bottom: 100 / @rem;

	.row {
		width: 100%;
		padding: 0 17 / @rem 10 / @rem;
		position: relative;
		label {
			display: inline-block;
			min-width: 50 / @rem;
			align-self: flex-start;
			line-height: 42 / @rem;
		}

		input,
		textarea {
			flex: 1;
			height: 42 / @rem;
			padding: 11 / @rem;
			font-size: 14 / @rem;
			color: rgba(17, 17, 16, 0.3);
			border: 1 / @rem solid rgba(31, 30, 29, 0.1);
			border-radius: 12 / @rem;
			&::placeholder {
				font-family: Source Han Sans CN-Regular;
				font-size: 14 / @rem;
				color: rgba(17, 17, 16, 0.3);
			}
			&.arrow {
				position: relative;
				&::after {
					content: "";
					display: block;
					width: 5 / @rem;
					height: 10 / @rem;
					position: absolute;
					right: 10 / @rem;
					top: 16 / @rem;
					background-image: url(~@img/icon/btn_xl.png);
					background-repeat: no-repeat;
					background-size: contain;
				}
			}
		}
		textarea {
			height: auto;
			width: 100%;
			border: none;
		}

		&.title {
			&::after {
				position: absolute;
				right: 30 / @rem;
				font-size: 10 / @rem;
				content: attr(data-length);
				color: rgba(17, 17, 16, 0.3);
			}
		}
		&.content {
			> div {
				flex: 1;
				border: 1 / @rem solid rgba(31, 30, 29, 0.1);
				border-radius: 12 / @rem;
				padding-bottom: 18 / @rem;
			}
			&::after {
				position: absolute;
				right: 30 / @rem;
				bottom: 18 / @rem;
				content: attr(data-length);
				color: rgba(17, 17, 16, 0.3);
				font-size: 10 / @rem;
			}
		}
	}
	.select-student {
		width: 100%;
		padding: 17 / @rem;
		p.subtitle {
			padding-bottom: 10 / @rem;
			font-size: 16 / @rem;
			font-weight: bold;
			font-family: Source Han Sans CN-Medium;
		}
		.card {
			padding: 10 / @rem 11 / @rem;
			box-shadow: 0 3 / @rem 17 / @rem 0 rgba(143, 72, 0, 0.2);
			border-radius: 12 / @rem;
			margin-bottom: 15 / @rem;
			p {
				flex: 1;
				padding-right: 17 / @rem;
			}
			input[type="checkbox"] {
				-webkit-appearance: none;
				display: inline-block;
				width: 17 / @rem;
				height: 17 / @rem;
				border-radius: 50%;
				border: 1 / @rem solid rgba(31, 30, 29, 0.3);
				&:checked {
					border: 1 / @rem solid rgba(255, 162, 22, 1);
					background-color: rgba(255, 162, 22, 1);
					position: relative;
					&::after {
						content: "";
						display: inline-block;
						position: absolute;
						left: 50%;
						top: 50%;
						margin-left: -4 / @rem;
						margin-top: -4 / @rem;
						width: 9 / @rem;
						height: 7 / @rem;
						background-image: url(~@img/icon/btn_xzzq.png);
						background-size: cover;
						background-repeat: no-repeat;
					}
				}
			}
		}
	}
}
</style>
